import React from 'react'

import './styles.scss'

const ProfileLoader = () => (
  <div className="loader profile-loader">
    <div
      style={{
        borderBottom: '1px solid #ebeef0',
        padding: '23px 0',
      }}
    >
      <div
        className="loader-row"
        style={{
          width: 80,
          height: 80,
          marginRight: 24,
          display: 'inline-block',
          verticalAlign: 'top',
        }}
      />
      <div
        className="loader hidden-sm"
        style={{
          marginTop: 11,
          verticalAlign: 'top',
        }}
      >
        <div
          className="loader-row"
          style={{
            width: 90,
            height: 32,
            marginRight: 9,
            display: 'inline-block',
          }}
        />
        <div
          className="loader-row"
          style={{
            width: 90,
            height: 32,
            marginRight: 9,
            display: 'inline-block',
          }}
        />
        <div
          className="loader-row"
          style={{
            width: '200%',
            height: 12,
            marginTop: 12,
            display: 'inline-block',
          }}
        />
      </div>
    </div>
    <div
      style={{
        borderBottom: '1px solid #ebeef0',
        padding: '28px 0 15px',
      }}
    >
      <div
        style={{
          maxWidth: 410,
        }}
      >
        <div className="input-loader input-loader--sm">
          <div
            className="loader-row"
            style={{
              width: '40%',
              height: 13,
              marginBottom: 10,
            }}
          />
          <div
            className="loader-row"
            style={{
              width: '100%',
              height: 48,
              marginBottom: 12,
            }}
          />
        </div>
        <div className="input-loader input-loader--sm">
          <div
            className="loader-row"
            style={{
              width: '40%',
              height: 13,
              marginBottom: 10,
            }}
          />
          <div
            className="loader-row"
            style={{
              width: '100%',
              height: 48,
              marginBottom: 12,
            }}
          />
        </div>
      </div>
      <div
        style={{
          maxWidth: 410,
        }}
      >
        <div className="input-loader">
          <div
            className="loader-row"
            style={{
              width: '40%',
              height: 13,
              marginBottom: 10,
              marginTop: 6,
            }}
          />
          <div
            className="loader-row"
            style={{
              width: '100%',
              height: 50,
              marginBottom: 8,
            }}
          />
        </div>
      </div>
    </div>
    <div style={{ margin: '24px 0 8px' }}>
      <div
        className="loader-row"
        style={{
          width: 72,
          height: 40,
          marginRight: 8,
          display: 'inline-block',
        }}
      />
      <div
        className="loader-row"
        style={{
          width: 84,
          height: 40,
          display: 'inline-block',
        }}
      />
    </div>
  </div>
)

ProfileLoader.displayName = 'ProfileLoader'

export default ProfileLoader
